// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { autocompleteProductsStyles } from "@stoneage/Overrides/Widgets/Header/AutocompleteProducts";
import { fontConfig } from "@stoneage/XDL/constants";
import { css } from "styled-components";
import { ellipsis } from "@stoneage/XDL/Utilities";

autocompleteProductsStyles.headerWrapper = {
    css: css`
        display: flex;
        align-items: center;
        gap: 24px;
        margin-bottom: 12px;
    `,
};

autocompleteProductsStyles.headerText = {
    variant: "h5",
    forwardAs: "p",
    css: css`
        margin-bottom: 0;
    `,
};

autocompleteProductsStyles.headerLink = {
    typographyProps: {
        ...fontConfig.smallSingleLine,
    },
};

autocompleteProductsStyles.productsWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};

autocompleteProductsStyles.container = {
    gap: 12,
};

autocompleteProductsStyles.imageGridItem = {
    width: 3,
    css: css`
        max-width: 64px;
        max-height: 64px;
        flex-basis: 64px;
        padding: 0;
    `,
};

autocompleteProductsStyles.infoGridItem = {
    width: 9,
    css: css`
        max-width: calc(100% - 64px);
        flex-basis: calc(100% - 64px);
        flex-direction: column;
        gap: 8px;
    `,
};

autocompleteProductsStyles.titleLink = {
    color: "secondary",
    typographyProps: {
        ...fontConfig.regularSingleLine,
        weight: fontConfig.weight.bold,
        css: css`
            ${ellipsis(2)}
        `,
    },
    css: css`
        align-self: baseline;
    `,
};

autocompleteProductsStyles.erpNumberText = {
    ...fontConfig.xSmallSingleLine,
    weight: fontConfig.weight.regular,
};

autocompleteProductsStyles.erpNumberValue = {
    ...fontConfig.xSmallSingleLine,
    weight: fontConfig.weight.medium,
};
